import { FC, useEffect, useRef } from "react";
import { useParams } from "react-router-dom";
import useI18n from "../../../../../hooks/useTranslations";
import { useRoofSubstructuresApi } from "../../../../../http/patrol/useRoofSubstructures";
import FlexContent from "../../../../ui/FlexContent";
import Header from "../../../../ui/Header";
import { PATROL } from "../../AdminSystemSettings";
import RoofSubstructureForm from "./RoofSubstructureForm";

const RoofSubstructure: FC = () => {
  const i18n = useI18n();
  const { systemId } = useParams<{ systemId: string }>();
  const { roofSubstructureId } = useParams<{ roofSubstructureId: string }>();
  const roofSubstructuresApi = useRoofSubstructuresApi();

  const aborter = useRef(new AbortController());
  const { error, data, isMutating, trigger } = roofSubstructuresApi.getAdminRoofSubstructure(aborter.current.signal);

  const path = [
    { url: `/admin/systems`, display: i18n.translation.systems.all },
    { url: `/admin/systems/${systemId}`, display: PATROL },
    {
      url: `/admin/systems/${systemId}/settings?tab=2&r_t=2`,
      display: `${i18n.translation.common.settings}: ${i18n.translation.roofSubstructures.plural}`,
    },
    { display: data?.name ?? "" },
  ];

  useEffect(() => {
    roofSubstructureId && trigger(roofSubstructureId);
  }, [roofSubstructureId]);

  return (
    <>
      <Header title={`${i18n.translation.roofSubstructures.singular}: ${data?.name ?? ""}`} error={error} path={path} />
      <FlexContent padding direction="row">
        <RoofSubstructureForm roofSubstructure={!error ? data : undefined} disabled={isMutating || !!error} />
      </FlexContent>
    </>
  );
};

export default RoofSubstructure;
